import React, { useEffect, useReducer, useState, useMemo } from "react"

import { BankRateTemplate } from "components/templates/top/bank_rate"
import {
  requestPriceListAPIs,
  usePriceList,
} from "components/actions/priceList"
import { APIResponse } from "redux/apis/types"
import uuid from "uuid"
import store from "redux/store"
import { LoadStateType, pageLoadRegist } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

const initialPriceListState = {
  name: "Top.PIR",
}

export const BankRate = () => {
  const [priceListState, usePriceListReducer] = useReducer(
    usePriceList,
    initialPriceListState
  )
  const [rateList, setRateList] = useState<APIResponse.Res>({})
  const loadResistId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  useEffect(() => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
      setRateList(data)
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [priceListState])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) {
      store.dispatch(pageLoadRegist(loadResistId, true))
      requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
        setRateList(data)
        store.dispatch(pageLoadRegist(loadResistId, false))
      })
    }
  }, [isPageLoading])

  return (
    <BankRateTemplate
      bankRateList={rateList}
      bankRateAction={usePriceListReducer}
    />
  )
}
